//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./methodology.d.ts" />

import * as $ from "skir-client";

// -----------------------------------------------------------------------------
// struct Methodology.Item
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `Methodology.Item.Mutable`.
 *
 * @alias Methodology.Item
 */
class Methodology_Item extends $._FrozenBase {}

function initMethodology_Item(target, initializer) {
  target.name = initializer.name ?? "";
  target.description = initializer.description ?? "";
}

// -----------------------------------------------------------------------------
// struct Methodology
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `Methodology.Mutable`. */
export class Methodology extends $._FrozenBase {}

function initMethodology(target, initializer) {
  target.name = initializer.name ?? "";
  target.description = initializer.description ?? "";
  target.items = $._toFrozenArray(
    initializer.items || [],
    Methodology_Item.create,
  );
  target.id = initializer.id ?? "";
  target.tags = $._toFrozenArray(
    initializer.tags || []);
    target.enabled = initializer.enabled ?? false;
}

// -----------------------------------------------------------------------------
// struct MethodologyList
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MethodologyList.Mutable`. */
export class MethodologyList extends $._FrozenBase {}

function initMethodologyList(target, initializer) {
  target.methodologies = $._toFrozenArray(
    initializer.methodologies || [],
    Methodology.create,
  );
}

// -----------------------------------------------------------------------------
// struct MethodologyStatus.Item
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `MethodologyStatus.Item.Mutable`.
 *
 * @alias MethodologyStatus.Item
 */
class MethodologyStatus_Item extends $._FrozenBase {}

function initMethodologyStatus_Item(target, initializer) {
  target.name = initializer.name ?? "";
  target.evidence = initializer.evidence ?? "";
  target.rephrasedEvidence = initializer.rephrasedEvidence ?? "";
}

// -----------------------------------------------------------------------------
// struct MethodologyStatus
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MethodologyStatus.Mutable`. */
export class MethodologyStatus extends $._FrozenBase {}

function initMethodologyStatus(target, initializer) {
  target.checkedItems = $._toFrozenArray(
    initializer.checkedItems || [],
    MethodologyStatus_Item.create,
  );
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "methodology.skir",
  [
    {
      kind: "struct",
      ctor: Methodology_Item,
      initFn: initMethodology_Item,
      name: "Item",
      parentCtor: Methodology,
      fields: [
        {
          name: "name",
          property: "name",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "description",
          property: "description",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: Methodology,
      initFn: initMethodology,
      name: "Methodology",
      fields: [
        {
          name: "name",
          property: "name",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "description",
          property: "description",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "items",
          property: "items",
          number: 2,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: Methodology_Item,
            },
            keyChain: "name",
          },
          mutableGetter: "mutableItems",
          indexable: {
            searchMethod: "searchItems",
            keyFn: (v) => v.name,
          },
        },
        {
          name: "id",
          property: "id",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "tags",
          property: "tags",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableTags",
        },
        {
          name: "enabled",
          property: "enabled",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MethodologyList,
      initFn: initMethodologyList,
      name: "MethodologyList",
      fields: [
        {
          name: "methodologies",
          property: "methodologies",
          number: 0,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: Methodology,
            },
            keyChain: "name",
          },
          mutableGetter: "mutableMethodologies",
          indexable: {
            searchMethod: "searchMethodologies",
            keyFn: (v) => v.name,
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MethodologyStatus_Item,
      initFn: initMethodologyStatus_Item,
      name: "Item",
      parentCtor: MethodologyStatus,
      fields: [
        {
          name: "name",
          property: "name",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "evidence",
          property: "evidence",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "rephrased_evidence",
          property: "rephrasedEvidence",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MethodologyStatus,
      initFn: initMethodologyStatus,
      name: "MethodologyStatus",
      fields: [
        {
          name: "checked_items",
          property: "checkedItems",
          number: 0,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MethodologyStatus_Item,
            },
            keyChain: "name",
          },
          mutableGetter: "mutableCheckedItems",
          indexable: {
            searchMethod: "searchCheckedItems",
            keyFn: (v) => v.name,
          },
        },
      ],
    },
  ]
);
